import { withStyles } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#FFFCD1",
      color: "rgba(0, 0, 0, 0.9)",
      fontSize: 11,
    },
  }))(Tooltip);

  export default LightTooltip;


// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/LightTooltip.js